<template>
  <v-card class="sellerStatistic" flat>
    <AdminToolbar
      :searchTypes="searchTypes" 
      :search_condition.sync="search_condition"
      :sortTypes="sortTypes"
      :sort.sync="sort"
      :tabs="tabs"
      :tab.sync="tab"
      @searching="searching"
    ></AdminToolbar>

    <div class="table" v-infinite-scroll="getSellerStatistic" infinite-scroll-disabled="busy" infinite-scroll-distance="150">
      <v-row class="table-header" no-gutters>
        <v-col>主播</v-col>
        <v-col>長片數</v-col>
        <v-col>長片收入</v-col>
        <v-col>限時動態數</v-col>
        <v-col>限時動態收入</v-col>
        <v-col>寫真數</v-col>
        <v-col>寫真收入</v-col>
        <v-col>原味衣物數</v-col>
        <v-col>原味衣物收入</v-col>
        <v-col>聊天數</v-col>
        <v-col>聊天收入</v-col>
        <v-col>解鎖商品數</v-col>
        <v-col>解鎖商品收入</v-col>
        <v-col>總收入</v-col>
      </v-row>

      <div class="table-body">
        <template v-for="seller in sellers">
          <v-row class="table-content" no-gutters :key="seller.id">
            <v-col>
              <v-avatar size="40" class="mr-2">
                <v-img :src="$HOST_URL + seller.usericon"/>
              </v-avatar>
                {{ seller.nickname }}
            </v-col>
            <v-col>{{ seller.video_count }}</v-col>
            <v-col>
              <div class="peach"></div>
              {{ seller.video_sold }}
            </v-col>
            <v-col>{{ seller.story_count }}</v-col>
            <v-col>
              <div class="peach"></div>
              {{ seller.story_sold }}
            </v-col>
            <v-col>{{ seller.photo_count }}</v-col>
            <v-col>
              <div class="peach"></div>
              {{ seller.photo_sold }}
            </v-col>
            <v-col>{{ seller.clothes_count }}</v-col>
            <v-col>
              <div class="peach"></div>
              {{ seller.clothes_sold }}
            </v-col>
            <v-col>
              <div class="peach"></div>
              {{ seller.video_sold + seller.story_sold + seller.photo_sold + seller.clothes_sold }}
            </v-col>
          </v-row>
        </template>
      </div>
    </div>
  </v-card>
</template>

<script>
import AdminToolbar from '@/components/admin/AdminToolbar'
export default {
  components: { AdminToolbar },
  data() {
    return {
      busy: false,
      page: 1,
      searchTypes: [
        { text: '手機號碼', table: 'sellers', column: 'tel' },
        { text: '主播暱稱', table: 'sellers', column: 'nickname' },
        { text: 'Email', table: 'sellers', column: 'email' },
      ],
      sortTypes: [
        { text: '建立日期', table: 'products', column: 'created_at', by: 'desc' },
      ],
      sort: '',
      tabs: [],
      tab: 0,
      search_condition: [],
      sellers: []
    }
  },
  methods: {
    searching() {
      this.busy = false
      this.page = 1
      this.sellers = []
      this.getSellerStatistic()
    },
    getSellerStatistic() {
      this.busy = true
      this.axios(`/admin/sellers/statistics?page=${this.page}&size=50`).then(response => {
        this.sellers = this.sellers.concat(response.data.data)
      })
      if(this.page != response.data.last_page) {
        this.page += 1
        this.busy = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.sellerStatistic {

}
</style>